module.exports = __webpack_public_path__ + "img/badge_salabam_vivamod.c75cdc0b.jpg";